module.exports = __webpack_public_path__ + "eddbbc629def6aa237965521b3af404f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Medium.ttf
// module id = 1813
// module chunks = 1